/**
 * Blog Accordion Script
 * Handles accordion card interactions for blog lists
 * Uses event delegation for dynamic content
 */

// 중복 선언 방지
if (typeof window.initBlogAccordion === 'undefined') {
  window.initBlogAccordion = function() {
    // 이미 초기화되었는지 확인
    if (document.body.dataset.accordionInit) return;
    document.body.dataset.accordionInit = 'true';

    // Event Delegation: body에 이벤트 리스너 등록
    document.body.addEventListener('click', function(e) {
      // 클릭된 요소가 accordion-item 내부인지 확인
      const accordionItem = e.target.closest('.accordion-item');
      if (!accordionItem) return;

      // accordion-item-button이 클릭된 경우에만 작동
      if (!e.target.closest('.accordion-item-button') && !e.target.closest('.accordion-item-subject')) {
        return;
      }

      const content = accordionItem.querySelector('.accordion-item-content');
      if (!content) return;

      const isOpen = accordionItem.classList.contains('open');

      if (isOpen) {
        // 닫기
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0px';
        });
        accordionItem.classList.remove('open');
      } else {
        // 열기
        accordionItem.classList.add('open');
        content.style.height = content.scrollHeight + 'px';

        // 열려있는 다른 요소들을 닫기
        const openAccordionItems = document.querySelectorAll('.accordion-item.open');
        openAccordionItems.forEach(openAccordionItem => {
          if (openAccordionItem !== accordionItem) {
            openAccordionItem.classList.remove('open');
            const openAccordionItemContent = openAccordionItem.querySelector('.accordion-item-content');
            if (openAccordionItemContent) {
              openAccordionItemContent.style.height = openAccordionItemContent.scrollHeight + 'px';
              requestAnimationFrame(() => {
                openAccordionItemContent.style.height = '0px';
              });
            }
          }
        });

        // 애니메이션 끝난 후 height를 auto로 변경 (반응형 대응)
        const transitionHandler = function() {
          if (accordionItem.classList.contains('open')) {
            content.style.height = 'auto';
          }
          content.removeEventListener('transitionend', transitionHandler);
        };
        content.addEventListener('transitionend', transitionHandler);
      }
    });
  };
}

// DOM이 로드되면 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', window.initBlogAccordion);
} else {
  window.initBlogAccordion();
}